import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(generateInterval);

import addMinutes from 'date-fns/addMinutes';
import formatDate from 'date-fns/format';

function generateInterval(startDate, intervalPeriod) {
  var prevDate, newDate, _ref;

  return _regeneratorRuntime.wrap(function generateInterval$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return startDate;

        case 2:
          prevDate = startDate;
          newDate = addMinutes(startDate, intervalPeriod);

        case 4:
          if (!(prevDate.getDay() === newDate.getDay())) {
            _context.next = 12;
            break;
          }

          _context.next = 7;
          return newDate;

        case 7:
          _ref = [newDate, addMinutes(newDate, intervalPeriod)];
          prevDate = _ref[0];
          newDate = _ref[1];
          _context.next = 4;
          break;

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function formatLocale(date, timeFormat) {
  return {
    label: formatDate(date, timeFormat),
    value: formatDate(date, timeFormat)
  };
}

export function generateTimeIntervals(intervalPeriod, format) {
  var startDate = new Date(1970, 0, 1, 0, 0, 0);
  var dates = [];
  var intervalGenerator = generateInterval(startDate, intervalPeriod);
  var interval = intervalGenerator.next();

  while (!interval.done) {
    dates.push(formatLocale(interval.value, format));
    interval = intervalGenerator.next();
  }

  return dates;
}